import Payments from '../../components/Payments/Payments';
import PaymentModal from '../../components/Payments/PaymentsModal/PaymentModal';
import paymentsModal from './paymentsModal';
import { paymentLoader, paymentsLoader, updateBusinessUrl } from './paymentsLA';
import GenericPage from '../../pages/GenericPage';
import paymentCreate from './paymentCreate';

const paymentsRoutes = [
  {
    path: 'payments',
    element: <GenericPage />,
    handle: {
      crumb: () => 'Payments',
    },
    children: [
      {
        path: '',
        element: <Payments />,
        loader: paymentsLoader,
        handle: {
          linkTo: {
            label: 'New',
            to: 'new',
          },
        },

        children: [
          {
            path: ':paymentId',
            element: <PaymentModal />,
            loader: paymentLoader,
            id: 'paymentData',
            children: [...paymentsModal],
          },
        ],
      },
      {
        path: 'update-business-url',
        action: updateBusinessUrl,
      },
      ...paymentCreate,
    ],
  },
];

export default paymentsRoutes;
